export default __webpack_public_path__ + "static/media/milestone 1300.26b76dab.svg";